import { GroupBaselineApiEndpoints } from '@contracts';

export const GROUP_BASELINE_ENDPOINTS: GroupBaselineApiEndpoints = {
  get: {
    group: {
      path: 'baseline_group/',
    },
    graph: {
      path: 'baseline_graph/',
    },
    log: {
      path: 'baseline_notification/',
    },
  },

  create: {
    group: {
      path: 'baseline_group/',
    },
  },

  update: {
    group: {
      path: 'baseline_group/',
    },
  },

  delete: {
    group: {
      path: 'baseline_group/',
    },
  },
};
